import React, { useEffect, useState } from 'react';
import RecaptchaNotice from './RecaptchaNotice';

/**
 * Tab 3: Continue on WhatsApp
 * Matches original ASTUDIO form success message exactly
 */
const Tab3_WhatsApp = ({ formData }) => {
  const [whatsappUrl, setWhatsappUrl] = useState('');

  useEffect(() => {
    // Prepare WhatsApp message
    const firstName = formData?.first_name || 'Candidate';
    const lastName = formData?.last_name || '';
    const fullName = `${firstName} ${lastName}`.trim();
    const position = formData?.position || 'a position';
    const email = formData?.email || '';

    const message = `Hi ASTUDIO!\nI'm ${fullName}, and I just applied for the ${position} role.\nHere is my email: ${email}\nI would like to join the A-TEAM.`;

    // WhatsApp phone number (without + and spaces)
    const whatsappNumber = '971527705712';

    // Create WhatsApp URL
    const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
    setWhatsappUrl(url);
  }, [formData]);

  return (
    <div className="tab-content">
      <div className="whatsapp-continue-container" style={{ textAlign: 'left', padding: '40px 0' }}>
        <div className="whatsapp-instruction" style={{
          fontFamily: '"Neutra Text", Helvetica, Arial, Verdana, sans-serif',
          fontSize: '16px',
          textTransform: 'uppercase',
          letterSpacing: '1px',
          color: '#322625',
          marginBottom: '20px',
          fontWeight: 'bold',
          lineHeight: '1.2'
        }}>
          CONTINUE ON WHATSAPP
        </div>

        {whatsappUrl && (
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-continue-btn btn-primary"
            style={{
              width: '200px',
              height: '55px',
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontFamily: '"Neutra Text"',
              letterSpacing: '1px',
              fontWeight: 700,
              fontSize: '14px',
              lineHeight: '17px',
              textTransform: 'uppercase',
              border: '1px solid #322625',
              textDecoration: 'none',
              overflow: 'hidden',
              transition: '0.5s all',
              color: '#322625',
              zIndex: 1,
              background: 'white',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = 'transparent';
              e.currentTarget.style.backgroundColor = '#bfe5e6';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = '#322625';
              e.currentTarget.style.backgroundColor = 'white';
            }}
          >
            LET'S GO
          </a>
        )}

        {/* reCAPTCHA Notice */}
        <RecaptchaNotice />
      </div>
    </div>
  );
};

export default Tab3_WhatsApp;
